module.exports = __webpack_public_path__ + "static/media/care-advice.e60969e1.jpg";